"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMuiTheme = void 0;
var _breakpoints = _interopRequireDefault(require("./tokens/breakpoints"));
const light = 'light';
const defaultMuiTheme = exports.defaultMuiTheme = {
  // Material UI attributes
  breakpoints: {
    values: {
      xs: _breakpoints.default.values.xs,
      sm: _breakpoints.default.values.sm,
      md: _breakpoints.default.values.md,
      lg: _breakpoints.default.values.lg,
      xl: _breakpoints.default.values.xl
    }
  },
  palette: {
    type: light
  }
};